import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { CheckRounded, CloseRounded } from '@material-ui/icons';
import InnerBox from 'Common/components/Boxes/InnerBox';
import colors from 'Common/constants/colors';

const Wrapper = styled(InnerBox)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    z-index: 1;

    @media screen and (min-width: 580px) {
        width: 345px;
    }
`;

const Question = styled.button`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 10px 20px;
    background: none;
    border: 0 none;
    color: ${colors.DARK_GRAY};
    cursor: pointer;

    &:hover,
    &:focus {
        outline: 0 none;
    }

    &[disabled] {
        cursor: not-allowed;
    }

    ${ifProp(
        'isAnswered',
        css`
            color: ${colors.GRAY};

            &:hover {
                background: ${colors.OUTER_BOX_BACKGROUND};
                color: ${colors.DIRTY_WHITE};
            }
        `,
    )}

    ${ifProp(
        'isActive',
        css`
            color: ${colors.WHITE};
            cursor: default;

            &:hover {
                color: ${colors.WHITE};
                background: none;
            }
        `,
    )}
`;

const CorrectIcon = styled(CheckRounded)`
    flex: 0 0 24px;
    color: ${colors.GREEN};
    margin-right: 10px;
`;

const WrongIcon = styled(CloseRounded)`
    flex: 0 0 24px;
    color: ${colors.ERROR};
    margin-right: 10px;
`;

const Title = styled.div`
    flex: 1;
    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

const QuestionsSidebarMenu = ({
    elementRef,
    questions,
    questionNumber,
    isLoading,
    isShowingMistakes,
    correctlyAnsweredQuestionNumbers,
    answeredQuestionNumbers,
    onQuestionNumberChange,
}) => (
    <Wrapper ref={elementRef}>
        {questions.map((question, index) => {
            const number = index + 1;
            const isActive = number === questionNumber;
            const isAnswered = answeredQuestionNumbers.includes(number);

            const isCorrect = correctlyAnsweredQuestionNumbers.includes(number);

            return (
                <Question
                    key={question.id}
                    isAnswered={isAnswered}
                    isActive={isActive}
                    disabled={isLoading}
                    onClick={
                        isLoading
                            ? undefined
                            : () => onQuestionNumberChange(number)
                    }
                >
                    {isShowingMistakes && isCorrect && <CorrectIcon />}
                    {isShowingMistakes && !isCorrect && <WrongIcon />}
                    <Title>{`${number}. ${question.title}`}</Title>
                </Question>
            );
        })}
    </Wrapper>
);

QuestionsSidebarMenu.propTypes = {
    questions: PropTypes.array.isRequired,
    questionNumber: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isShowingMistakes: PropTypes.bool.isRequired,
    correctlyAnsweredQuestionNumbers: PropTypes.array.isRequired,
    answeredQuestionNumbers: PropTypes.array.isRequired,
    onQuestionNumberChange: PropTypes.func.isRequired,
};

export default QuestionsSidebarMenu;
